import styled from 'styled-components'

export const ActionLinksWrapper = styled.div`
  position: absolute;
  right: 37px;
  top: -10px;
  display: flex;
  gap: 16px;

  & > {
    margin-left: 15px;
  }
  .button-delete {
    display: block;
    position: relative;
    float: left;
  }
  & > * {
    margin: 0 20px 0 0;
  }

  .unbook-button {
    float: right;
  }
`
